/** * @author Akhila * @email 83606@global.ul.com * @create date 2020-08-28 15:52:48 *
@modify date 2020-08-28 15:52:48 * @desc Dashboard layout */
<template>
  <div class="dashboard-container">
    <div class="container-responsive">
      <div class="row" v-if="displayPanel">
        <carousel-widget
          :isDefault="isDefault"
          v-if="
            displayPanel.card_widget_info[0].cardType === 'headline' &&
            displayPanel.card_widget_info[0].card_number === 1
          "
          @openAddPopup="openAddPopup()"
          @openEditPopup="openEditPopup('Main Headline')"
        ></carousel-widget>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <div class="row">
            <div v-for="panel in displayPanel.card_widget_info" :key="panel.card_number">
              <div
                class="col-xs-12 col-sm-6 col-md-6 col-lg-12"
                v-if="
                  panel.cardType === 'single' &&
                  [2,3].includes(panel.card_number)
                "
              >
                <div
                  class="widget-card widget-margin-bottom-25 single-widget-ht"
                  :class="{
                    'pd-24': [12,13,17].includes(panel.panel_widget_id),
                  }"
                >
                  <single-card-component
                    :panel="panel"
                    :sbData="sbData"
                    :sxData="sxData"
                    :permissions="permissions"
                  ></single-card-component>
                  <div
                    class="col-md-12 footer bt-32 rt-24"
                    v-if="panel.panel_widget_id != 3"
                  >
                    <span class="seeMore" @click="redirect(panel.panel_widget_id)"
                      >See All</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="panel in displayPanel.card_widget_info" :key="panel.card_number">
          <div
            :class="{
              'col-xs-12 col-sm-12 col-md-12 col-lg-4': panel.cardType === 'single',
              'col-xs-12 col-sm-12 col-md-12 col-lg-6': panel.cardType === 'combo',
              'col-xs-12 col-sm-12 col-md-12 col-lg-12': panel.cardType === 'horizontal',
            }"
            v-if="
              panel.card_number != 1 && panel.card_number != 2 && panel.card_number != 3
            "
          >
            <div
              class="row p-relative"
              :class="{
                'widget-card': panel.cardType !== 'horizontal',
                'combo-widget-ht': panel.cardType === 'combo',
                'single-widget-ht': panel.cardType === 'single',
                'pd-0': panel.panel_widget_id == 8,
                'pd-24': [12,13,14,15,17,19].includes(panel.panel_widget_id),
                'pd-custom-projects': panel.panel_widget_id == 16,
                // 'ht-500': panel.cardType == 'horizontal',
                'widget-margin-bottom-25': panel.cardType != 'horizontal',
                'upcoming-widget-pd':
                  panel.cardType === 'combo' && panel.panel_widget_id == 3,
              }"
            >
              <single-card-component
                v-if="panel.cardType === 'single'"
                :panel="panel"
                :sbData="sbData"
                :sxData="sxData"
                :name="panel.displayName"
                :permissions="permissions"
              ></single-card-component>
              <combo-card-component
                v-if="panel.cardType === 'combo'"
                :panel="panel"
                :sbData="sbData"
                :sxData="sxData"
                :name="panel.displayName"
                type="combo"
                :permissions="permissions"
              ></combo-card-component>
              <horizontal-card-component
                v-if="panel.cardType === 'horizontal'"
                :panel="panel"
                :sbData="sbData"
                :sxData="sxData"
                :permissions="permissions"
              ></horizontal-card-component>
              <div
                class="col-md-12 footer"
                :class="{
                  // 'pr-0': panel.cardType != 'horizontal',
                  'pr-0': panel.cardType == 'combo',
                  'bt-32 rt-25': panel.cardType == 'single',
                  'bt-10 rt-25': panel.cardType === 'horizontal',
                }"
                v-if="panel.panel_widget_id != 3"
              >
                <span class="seeMore" @click="redirect(panel.panel_widget_id)"
                  >See All</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import HeadlineCardComponent from './CardComponents/HeadlineCardComponent.vue';
import SingleCardComponent from './CardComponents/SingleCardComponent.vue';
import ComboCardComponent from './CardComponents/ComboCardComponent.vue';
import HorizontalCardComponent from './CardComponents/HorizontalCardComponent.vue';
import { getCookie } from '../../utils/common';
import {
  getPanelInfo,
  getCardTypeInfo,
  getPanelCardWidgetInfo,
  getWidgetListForAccount,
  getUserDashboardPreference,
} from '../../apis/dashboardCustomization';
import { SBLogin } from '../../apis/submissionBuilder';
import { SXLogin } from '../../apis/smartExchange';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import EventBus from '../../utils/event-bus';
import CarouselWidget from './CardComponents/DashboardWidgets/CarouselWidget.vue';

export default {
  mixins: [permissionsList],
  name: 'DashboardLayout',
  components: {
    HeadlineCardComponent,
    SingleCardComponent,
    ComboCardComponent,
    HorizontalCardComponent,
    // HeadlinesCard,
    CarouselWidget,
  },
  props: {
    isDefault: Boolean,
  },
  data() {
    return {
      permissions: [],
      token: '',
      displayPanel: null,
      panelInfo: [],
      cardTypeInfo: [],
      panelCardWidgetInfo: [],
      widgetList: [],
      userPreference: {},
      sbData: null,
      sxData: null,
      roleId: '',
    };
  },
  computed: {},
  methods: {
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    async intialAPIs() {
      this.loaderStatus = true;
      await Promise.all([
        this.getPanelInfo(),
        this.getCardTypeInfo(),
        this.getPanelCardWidgetInfo(),
        this.getWidgetListForAccount(),
        this.getUserDashboardPreference(),
      ]);
      await this.loadDashboard();
      this.loaderStatus = false;
    },
    async getPanelInfo() {
      this.panelInfo = await getPanelInfo();
    },
    async getCardTypeInfo() {
      this.cardTypeInfo = await getCardTypeInfo();
    },
    async getPanelCardWidgetInfo() {
      this.panelCardWidgetInfo = await getPanelCardWidgetInfo();
    },
    async getWidgetListForAccount() {
      this.widgetList = await getWidgetListForAccount(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).role_id
      );
    },
    async getUserDashboardPreference() {
      this.userPreference = await getUserDashboardPreference(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).id
      );
    },
    async loadDashboard() {
      if (
        this.userPreference &&
        this.userPreference.card_widgets &&
        this.userPreference.card_widgets.length > 0
      ) {
        this.selectedPanel = [];
        this.panelInfo.forEach((panel) => {
          if (panel.id === this.userPreference.panel_id) {
            this.displayPanel = this.panelCardWidgetInfo.find(
              (data) => data.panel_id === this.userPreference.panel_id
            );
          }
        });
        this.displayPanel.card_widget_info.forEach((p, i) => {
          const cardTypeIndex = this.cardTypeInfo.findIndex(
            (card) => card.id === p.card_type_id
          );
          this.displayPanel.card_widget_info[i].cardType = this.cardTypeInfo[
            cardTypeIndex
          ].name;
          const cardWidgetIndex = this.userPreference.card_widgets.findIndex(
            (card) => card.panel_card_id === p.id
          );
          this.displayPanel.card_widget_info[
            i
          ].panel_widget_id = this.userPreference.card_widgets[
            cardWidgetIndex
          ].panel_widget_id;
          this.widgetList.forEach((widget) => {
            if (widget.id === this.displayPanel.card_widget_info[i].panel_widget_id) {
              this.displayPanel.card_widget_info[i].displayName = widget.display_name;
              this.displayPanel.card_widget_info[i].premium_service_id =
                widget.premium_service_id;
              this.displayPanel.card_widget_info[i].service_name = widget.service_name;
            }
          });
        });
        const sbwidgets = this.displayPanel.card_widget_info.find(
          (widget) => widget.premium_service_id === 3
        );
        const sxwidgets = this.displayPanel.card_widget_info.find(
          (widget) => widget.service_name === 'Smart Exchange'
        );
        if (sbwidgets) {
          await this.loginSB();
        }
        if (sxwidgets) {
          await this.loginSX();
        }
      }
    },
    async loginSB() {
      const data = await SBLogin(this.token);
      this.sbData = data;
    },
    async loginSX() {
      const data = await SXLogin(this.token);
      this.sxData = data;
    },
    redirect(panelId) {
      let url = null;
      switch (panelId) {
        case 2:
          url = '/layout/alert';
          break;
        case 4:
          url = '/layout/market-place';
          break;
        case 9:
          url = '/layout/trackplusdashboard';
          break;
        case 5:
        case 6:
        case 7:
        case 8:
          url = '/layout/registration';
          break;
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
          url = '/layout/submission-builder';
          break;
        case 17:
        case 18:
        case 19:
          url = '/layout/smart-exchange';
          break;
        case 20:
          url = '/layout/regulatory-updates';
          break;
        default:
          break;
      }
      if (url) {
        this.$router.push(url);
        EventBus.$emit('activeMenuTitle', this.$route.meta.title);
      }
    },
    openAddPopup(type = 'Main Headline') {
      this.editObj = {};
      this.operationForAdd = {
        type,
        action_type: 'Add',
      };
      $('#addPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    openEditPopup(type) {
      this.operations = {
        action_type: 'Edit',
        type,
      };
      $('#listPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
  },
  async created() {
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    [, this.token] = getCookie('Authorization').split('Bearer ');
    await Promise.all([this.intialAPIs(), this.validateFeatures()]);
  },
  async mounted() {
    EventBus.$on('initializePage', async (data) => {
      if (data) {
        await this.intialAPIs();
      }
    });
  },
};
</script>
<style scoped>
.dashboard-container {
  font-family: Roboto;
  font-style: normal;
  background: #f2f2f2;
  padding: 20px;
  min-height: 100vh;
  height: 100%;
}
.widget-card {
  padding: 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
}
.widget-margin-bottom-25 {
  margin-bottom: 25px;
}
.headlines-ht {
  min-height: 520px !important;
  margin-bottom: 20px;
}
.combo-widget-ht {
  width: 100%;
  min-height: 326px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-left: 0px;
  margin-right: 0px;
  position: relative;
  padding-bottom: 40px;
  display: inline-block;
}
.upcoming-widget-pd {
  padding-bottom: 0px;
}
.single-widget-ht {
  height: 262px !important;
}
@media (min-width: 992px) and (max-width: 1200px) {
  .headlines-ht {
    min-height: 540px !important;
  }
  .single-widget-ht {
    height: 260px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .combo-widget-ht {
    min-height: 350px !important;
  }
}
@media only screen and (max-width: 767px) {
  .headlines-ht {
    min-height: auto !important;
  }
  .combo-widget-ht {
    min-height: auto !important;
  }
  .single-widget-ht {
    height: 300px !important;
  }
}
.pd-0 {
  padding: 0px;
}
.pd-24 {
  padding: 24px;
}
.pd-custom-projects {
  padding: 24px 24px 40px;
}
.ht-500 {
  height: 500px;
}
.bt-32 {
  bottom: 36px !important;
}
.footer {
  padding-right: 15px;
  position: absolute;
  bottom: 18px;
  right: 24px;
}
.p-relative {
  position: relative;
}
.seeMore {
  font-size: 16px;
  line-height: 19px;
  color: #2f80ed;
  float: right;
  cursor: pointer;
  font-weight: 500;
}
.bt-42 {
  bottom: 33px;
}
.rt-10 {
  right: 10px;
}
.rt-24 {
  right: 24px;
}
.bt-10 {
  bottom: 10px;
}
.pr-0 {
  padding-right: 0px;
}
.widget-margin-bottom-0 {
  margin-bottom: 0;
}
</style>
